import { AgGridReact } from '@ag-grid-community/react';
import { AgGridColumn } from '@ag-grid-community/react/lib/shared/agGridColumn';
import AdminSiteLink from 'admin/common/AdminSiteLink';
import defaultGridOptions from 'common/agGrid/defaultGridOptions';
import React from 'react';
import { Button } from 'react-bootstrap';
import UserRoleAssignment from './userRoleAssignment';

export interface UserRoleAssignmentListProps {
    assignments: UserRoleAssignment[];
    showMerchantColumn?: boolean;
    showRoleColumn?: boolean;
    showAddAssignment?: boolean;
    headerText: string;
    addButtonText: string;
    onShowAddAssignment(): void;
    onRemoveAssignment(userRoleAssignment: UserRoleAssignment): void;
}

const UserRoleAssignmentList: React.FC<UserRoleAssignmentListProps> = props => {

    if (props.assignments == null) return <></>;

    return <div className="ag-theme-alpine" style={{ width: "100%" }} >
        <div className="row table-header-row ml-0 mr-0">
            <div className="col">
                <div className="page-sub-header">
                    {props.headerText}
                </div>
            </div>
            {props.showAddAssignment &&
                <div className="col action-bar">
                    <Button onClick={props.onShowAddAssignment} variant="link" className="ml-auto">
                        <i className="material-icons">add_circle_outline</i> {props.addButtonText}
                    </Button>
                </div>
            }
        </div>

        <AgGridReact
            {...defaultGridOptions}
            paginationPageSize={25}
            pagination
            rowData={props.assignments}
            getRowId={params => `${params.data.user.userId}-${params.data.merchant?.id}-${params.data.role.id}`}
            domLayout="autoHeight"

            onGridReady={params => params.api.sizeColumnsToFit()}>
            <AgGridColumn field="user.name" headerName="User" />
            <AgGridColumn field="merchant" headerName="Merchant"
                cellRenderer={(params: any) => params.value == null
                    ? "None"
                    : <AdminSiteLink.MerchantDetails merchantId={params.value.id}>{params.value.name}</AdminSiteLink.MerchantDetails> }
                hide={!props.showMerchantColumn}
            />
            <AgGridColumn field="role" headerName="Role"
                cellRenderer={(params: any) =>
                    <AdminSiteLink.RoleDetails roleId={params.value.id}>{params.value.name}</AdminSiteLink.RoleDetails> }
                hide={!props.showRoleColumn} />
            <AgGridColumn
                cellRenderer={(params: any) => params.node.data.role.isUserAssignable
                    ? <button
                        className="link-button"
                        onClick={() => props.onRemoveAssignment(params.node.data)}>
                        <i className="material-icons">delete</i>
                    </button>
                    : <></>
                }
            />
        </AgGridReact>
    </div>
}

export default UserRoleAssignmentList;